import React from 'react';
import Button from 'components/Button';

import './styles.css';

const Buttons = ({closeModal, submitForm, submitting}) => {
  return (
    <div className="Buttons colab-row-space-between">
      <Button onClick={closeModal}>Cancel</Button>
      <Button
        onClick={submitForm}
        blue={!submitting}
        isLoading={submitting}
        disabled={submitting}>
        Yes
      </Button>
    </div>
  );
};

export default Buttons;
